import styled from 'styled-components'
import { Box } from '../UI/Box'
import { Background, ForceFullWidth } from '../Hero/styled'
import React, { ReactNode } from 'react'
import { Desktop, Mobile } from '../../page_components/DropDetails/parts/About'

const Relative = styled.div`
  position: relative;
`

const SectionWrapper = styled(Box)`
  padding: 459px 0 32px;
  z-index: 0;

  @media screen and (max-width: 768px) {
    padding: 169px 0 50px;
  }
`

const SectionTitle = styled.h3`
  color: ${({ theme }) => theme.semantics.zap.surface.primary};
  font-feature-settings: 'ss01' on;
  font-family: 'Space Grotesk';
  font-size: 32px;
  font-style: normal;
  font-weight: 300;
  line-height: 25px; /* 78.125% */
  letter-spacing: 9.6px;
  text-transform: uppercase;
  z-index: 1;

  @media screen and (max-width: 768px) {
    font-size: 28px;
    line-height: 36px;
    letter-spacing: 8.4px;
  }
`

export default function HowItWorks({
  backgroundUrl,
  title = 'How It Works',
  children,
}: {
  backgroundUrl: string
  title?: string
  children: ReactNode
}) {
  return (
    <Relative>
      <ForceFullWidth>
        <Background
          backgroundUrl={backgroundUrl}
          height="500px"
          mobileH="236px"
        />
      </ForceFullWidth>
      <SectionWrapper dc g={32}>
        <SectionTitle>{title}</SectionTitle>
        <CardContainer>{children}</CardContainer>
      </SectionWrapper>
    </Relative>
  )
}

function CardContainer({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Desktop>
        <Box g={32} jsb>
          {children}
        </Box>
      </Desktop>
      <Mobile>
        <CardCarousel>{children}</CardCarousel>
      </Mobile>
    </>
  )
}

const PaginationContainer = styled(Box)`
  padding-bottom: 32px;
`

const PaginationNumber = styled(Box)`
  border: 1px solid #888a8c;
  flex: 0;
  min-width: 44px;
  height: 44px;

  color: white;
  font-feature-settings: 'ss01' on;
  font-family: 'Space Grotesk';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.18px;
  text-transform: uppercase;
`

const CarouselShadow = styled.div`
  position: relative;

  &::before {
    content: '';
    background: linear-gradient(to left, black, transparent);
    height: 100%;
    width: 20%;
    position: absolute;
    right: 0;
    z-index: 100;
  }
`

const CarouselContainer = styled(Box)`
  overflow: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
  position: relative;
  z-index: 10;
  padding-right: 100px; // space for scroll
`

export function CardCarousel({ children }: { children: ReactNode }) {
  return (
    <CarouselShadow>
      {/* <PaginationContainer g={8}>
        {React.Children.map(children, (child, index) => (
          <PaginationNumber ac jc>
            {index + 1}
          </PaginationNumber>
        ))}
      </PaginationContainer> */}
      <CarouselContainer g={12}>{children}</CarouselContainer>
    </CarouselShadow>
  )
}

const StyledCard = styled(Box)`
  @media screen and (max-width: 768px) {
    flex: 1 0 auto;
    max-width: 307px;
  }

  img {
    margin-bottom: 20px;
    width: 100%;
    min-height: 220px;
    max-height: 220px;
    object-fit: cover;
  }
  h3 {
    color: ${({ theme }) => theme.semantics.zap.surface.primary};
    font-feature-settings: 'ss01' on;
    font-family: 'Space Grotesk';
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 4px;
  }
  h4 {
    color: ${({ theme }) => theme.colors.brandPrimary};
    font-feature-settings: 'ss01' on;
    font-family: 'Space Grotesk';
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 12px;
  }
  p {
    overflow: hidden;
    color: ${({ theme }) => theme.semantics.zap.surface.primary};
    font-feature-settings: 'ss01' on;
    text-overflow: ellipsis;
    font-family: 'Space Grotesk';
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 22px; /* 157.143% */
  }
`

export function Card({
  imageUrl,
  title,
  subTitle,
  text,
}: {
  imageUrl: string
  title: string
  subTitle: string
  text: string
}) {
  return (
    <StyledCard dc mw="426px">
      <img src={imageUrl} alt={title} />
      <h3>{title}</h3>
      <h4>{subTitle}</h4>
      <p>{text}</p>
    </StyledCard>
  )
}
